<template>
  <div>
    <el-dialog
      title="开播方式"
      :visible.sync="dialogVisible"
      :close-on-click-modal="true"
      :before-close="viewRoomInfoClose"
      width="50%"
    >
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="信息" name="first">
          <p>标题： {{ info.title }}</p>
          <p>百家云直播间ID： {{ info.chat_room_id }}</p>
        </el-tab-pane>
        <el-tab-pane label="助教" name="second">
          <p>
            <b
              >助教参加码：
              <span style="font-size: 16px; font-weight: 600; color: #1795ff">{{
                info.bjy_room_info.admin_code
              }}</span></b
            >
          </p>
          <p>
            请填写昵称：
            <b
              ><span style="font-size: 16px; font-weight: 600; color: #1795ff"
                >灵动生活助教</span
              ></b
            >
          </p>
          <el-divider content-position="left">电脑客户端直播方式</el-divider>
          <p>
            <el-link
              :underline="false"
              :href="info.bjy_client_download.mac"
              target="_blank"
              >MAC点击下载安装 <b>云端课堂</b> 客户端</el-link
            >
          </p>
          <p>
            <el-link
              :underline="false"
              :href="info.bjy_client_download.windows"
              target="_blank"
              >Windows点击下载安装 <b>云端课堂</b> 客户端</el-link
            >
          </p>
          <el-divider content-position="left">浏览器网页直播方式</el-divider>
          <p>
            浏览器网页进入：
            <el-link
              :underline="false"
              :href="info.bjy_admin_url"
              target="_blank"
              >{{ info.bjy_admin_url }}</el-link
            >
          </p>
        </el-tab-pane>
        <el-tab-pane label="讲师" v-if="info.live_type != 6" name="third">
          <div v-if="info.live_type != 4">            
            <p>
              <b
                >讲师参加码：
                <span style="font-size: 16px; font-weight: 600; color: #1795ff">{{
                  info.bjy_room_info.teacher_code
                }}</span></b
              >
            </p>
            <p>
              请填写昵称：
              <b
                ><span style="font-size: 16px; font-weight: 600; color: #1795ff"
                  >灵动生活讲师</span
                ></b
              >
            </p>
            <el-divider content-position="left">手机APP直播方式</el-divider>
            <p>
              讲师扫码安装APP
              <el-image
                style="width: 100px; height: 100px"
                :src="info.bjy_client_download.app"
                fit="cover"
              ></el-image>
            </p>
            <el-divider content-position="left">电脑客户端直播方式</el-divider>
            <p>
              <el-link
                :underline="false"
                :href="info.bjy_client_download.mac"
                target="_blank"
                >MAC点击下载安装 <b>云端课堂</b> 客户端</el-link
              >
            </p>
            <p>
              <el-link
                :underline="false"
                :href="info.bjy_client_download.windows"
                target="_blank"
                >Windows点击下载安装 <b>云端课堂</b> 客户端</el-link
              >
            </p>            
            <el-divider content-position="left">浏览器网页直播方式</el-divider>
            <p>
              浏览器网页进入：
              <el-link
                :underline="false"
                :href="info.bjy_teacher_url"
                target="_blank"
                >{{ info.bjy_teacher_url }}</el-link
              >
            </p>
            <el-divider content-position="left">灵动生活APP讲师直播方式</el-divider>
            <p>
              <div v-if="info.teacher.user_id == 0">
                还没有设置讲师&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button size="mini" type="primary" @click="setTeacher()">设置讲师</el-button>
              </div>
              <div v-if="info.teacher.user_id > 0">
                讲师用户ID：<b>{{ info.teacher.user_id }}</b>&nbsp;&nbsp;&nbsp;&nbsp;<el-button size="mini" type="primary" @click="setTeacher()">变更讲师</el-button>
                <p>讲师用户昵称：<b>{{ info.teacher.nickname }}</b></p>
                <p>讲师用户手机号：<b>{{ info.teacher.mobile_phone }}</b></p>
                <p>讲师用户头像：
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="info.teacher.avatar"
                    fit="cover"
                  ></el-image>
                </p>
              </div>
            </p>
          </div>
          <div v-if="info.live_type == 4">
            <!-- <p>
              <b
                >推流地址：
                <span style="font-size: 16px; font-weight: 600; color: #1795ff">{{
                  info.bjy_push_url
                }}</span></b
              >              
            </p> -->
            <p>
              <b
                >推流/rtmp地址：
                <span style="font-size: 16px; font-weight: 600; color: #1795ff">{{
                  info.bjy_push_url1
                }}</span></b
              >
            </p>
            <p>
              <b
                >直播码/密钥：
                <span style="font-size: 16px; font-weight: 600; color: #1795ff">{{
                  info.bjy_push_url2
                }}</span></b
              >
            </p>
            <p>
              <b
                >
                <span style="font-size: 16px; font-weight: 600; color: #ff3333">
                  推流码率 严禁超过 4000 ，否则百家云会拦截推流，导致无法推流，直播异常！！！
                </span></b
              >
            </p>
          </div>
          
        </el-tab-pane>

        <el-tab-pane label="学员" name="fourth">
          <div>
            <p>
              <b
                >课程链接：
                <span style="font-size: 16px; font-weight: 600; color: #1795ff">{{
                  info.live_url
                }}</span></b
              >&nbsp;&nbsp;<el-button type="text" @click="copy">复制</el-button>
            </p>
            <p>
              <div id="qrcode" style="margin-left: 256 /2; position: relative; left: 10%"></div>
            </p>
          </div>
        </el-tab-pane>
      </el-tabs>
      
    </el-dialog>
  </div>
</template>

<script>
import { qrCode, copyData } from "@/api/common";
import { getLiveRoomInfo, setLiveTeacher } from "@/api/live";

export default {
  name: "liveRoomInfo",
  props: {
  },
  data: function () {
    return {
      dialogVisible: false,
      activeName: 'first',
      info: {
        courseType: 3,
        title: "",
        chat_room_id: "",
        live_status: 0,
        bjy_client_download: {
          mac: "",
          windows: "",
          app: "",
        },
        bjy_admin_url: "",
        bjy_teacher_url: "",
        bjy_room_info: {
          admin_code: "",
          teacher_code: "",
        },
        teacher: {
          user_id: 0,
          nickname: "",
          mobile_phone: "",
          avatar: "",
        },
      },
    };
  },
  created: function () {
    
  },
  methods: {
    setTeacher() {
      this.$prompt("请输入讲师用户手机号", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^1[3456789]\d{9}$/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          setLiveTeacher({
            course_id: this.info.course_id,
            period_id: this.info.id,
            mobile_phone: value,
          }).then((response) => {
            if (response.status == 2000) {  
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
              this.dialogVisible = false;
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    copy() {
      copyData(this.info.live_url)
      this.$message({
          message: '复制成功',
          type: 'success'
      })
    },

    getLiveRoomInfo(period_id) {
      this.dialogVisible = true;
      getLiveRoomInfo({ period_id: period_id }).then((response) => {
        this.info = response.data;
        document.getElementById("qrcode").innerHTML = "";
        let qrcode = qrCode(this.info.live_url, 300, 300);
      })
    },
    
    viewRoomInfoClose() {
      this.dialogVisible = false;
      this.activeName = 'first';
      this.info = {
        title: "",
        chat_room_id: "",
        live_status: 0,
        bjy_client_download: {
          mac: "",
          windows: "",
          app: "",
        },
        bjy_admin_url: "",
        bjy_room_info: {
          admin_code: "",
          teacher_code: "",
        },
        teacher: {
          user_id: 0,
          nickname: "",
          mobile_phone: "",
          avatar: "",
        },
      }
    }
  },
  watch: {
  },
};
</script>

<style>
</style>